/* eslint-disable import/no-cycle */
import { APIService, APIServiceAllRoles } from './ApiService';

export const getCriticalAnnouncementForAdmin = () => APIService.get('announcements/critical');

export const getCriticalAnnouncement = () => APIServiceAllRoles.get('announcements/critical');

export const setCriticalAnnouncement = payload => APIService.post('announcements/critical', { ...payload });
